<template>
    <base-tippy
        class="mx-0.5 cursor-pointer self-center hover:text-red-600"
        content="Supprimer l'appareil"
        placement="bottom-end"
        @click.native="$emit('action')"
        @keyup.enter.stop.prevent="$emit('action')"
    >
        <base-icon
            icon="trash-alt"
            size="sm"
        ></base-icon>
    </base-tippy>
</template>

<script>
import BaseIcon from '../Base/BaseIcon'
import BaseTippy from '../Base/BaseTippy'

export default {
  name: 'DeleteDevice',
  components: {
    BaseTippy,
    BaseIcon
  }
}
</script>

<style scoped>

</style>
